import styled from "styled-components/macro";

export const FaqItemList = styled.ul`
  > li {
    margin-bottom: 16px;
  }
`;
